import environment from '../environment.json';
export default class EnvironementService {
    static config = environment;
}